import { Injectable, inject } from '@angular/core'

import { Store } from '@ngrx/store'

import {
  ActionTarget,
  ActionAgent,
} from '@flowx/designer/modules/ai/common/api/conversation-api.types'
import { nodesSelector } from '@flowx/designer/shared/store/selectors/node.selectors'
import { templatesConfigsById } from '@flowx/designer/shared/store/selectors/template-config.selectors'

import { AgentAction, AgentName } from './ai-conversation.commons'
import { isTargetComplete } from './conversation.utils'

@Injectable({
  providedIn: 'root',
})
export class ConversationUtilsService {
  #store = inject(Store)
  nodes = this.#store.selectSignal(nodesSelector)

  isTargetValid(
    agent: ActionAgent,
    target: ActionTarget
  ): boolean {
    const isTargetCompleteResult = isTargetComplete(agent, target)
    if (!isTargetCompleteResult) {
      return false
    }

    return this.targetExists(agent, target)
  }

  targetExists(
    agent: ActionAgent,
    target: ActionTarget
  ): boolean {
    if (agent.agent === AgentName.AiAnalyst) {
      return true
    }

    const nodes = this.nodes()
    const node = nodes.find((node) => node.id === parseInt(target?.node?.id ?? '', 10))

    if (agent.agent === AgentName.AiDesigner) {
      return !!node
    }

    if (agent.agent === AgentName.AiDeveloper) {
      if (
        [AgentAction.BusinessRule, AgentAction.EditBusinessRule].includes(
          agent.action as AgentAction
        )
      ) {
        return !!node
      }

      if (agent.action === AgentAction.Expression) {
        const templateConfig = this.#store.selectSignal(
          templatesConfigsById(node?.navigationAreaId, parseInt(target.expression?.elementId, 10))
        )()
        return !!templateConfig
      }
    }

    return true
  }
}
